import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  createHttpLink,
  from,
} from '@apollo/client';
import { RestLink } from 'apollo-link-rest';
import { API_HOST, GQL_HOST } from 'src/config-global';
import { getTraceHeaders } from 'src/services/sentry';
import { Session } from 'src/state/session';

const cache = new InMemoryCache({
  typePolicies: {
    TableRowColumn: {},

    User: {
      merge: true,
    },
    Query: {
      fields: {
        board: {
          merge: true,
          read(_, { args, toReference }) {
            return toReference({
              __typename: 'Board',
              _id: args?.id,
            });
          },
        },
        todoItems: {
          keyArgs: (args: any) => args.queryParams,
        },
        tableRows: {
          //? ignore cache when filter or groupBy changes.
          //? this allow is to manually update the cache when create a new row
          keyArgs: ({ input }: any) =>
            JSON.stringify({
              boardId: input?.boardId,
              tableId: input?.tableId,
            }),
          merge: false,
        },
      },
    },
  },
  possibleTypes: {
    BoardAssigned: ['User', 'Team'],
  },
});

const httpLink = createHttpLink({
  uri: GQL_HOST,
});

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: Session.getToken() || null,
      ...getTraceHeaders(),
    },
  }));

  return forward(operation);
});

const restLink = new RestLink({ uri: API_HOST });

export const client = new ApolloClient({
  cache,
  link: from([authMiddleware, restLink, httpLink]),
});
